import React, { useState, useEffect, use } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { DataGrid } from '@material-ui/data-grid';
import { Button, Modal, Form, Row, Col, InputGroup } from "react-bootstrap";
import SearchIcon from '@material-ui/icons/Search';
import * as Admin from "../../../store/ducks/admin.duck";
import { Grid, Paper, makeStyles } from '@material-ui/core';
import { format } from "date-fns";
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../../../_metronic/_assets/css/app.css';
import '../../../../_metronic/_assets/css/app2.css';

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
    formControl: {
      margin: 0, //theme.spacing(1),
      minWidth: 120,
    },
    formControlWide: {
      margin: 0, //theme.spacing(1),
      minWidth: '100%',
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    label: {
      backgroundColor: '#fff',
      paddingLeft: 3,
      paddingRight: 3,
    }
  }));


export default function RecentArchived() {

  const [searchTerm, setSearchTerm] = useState('')
  const recentArchived = useSelector(state => state.admin.RecentArchived)
  const filters = useSelector(state => state.admin.Filters)
  const dispatch = useDispatch()
  const classes = useStyles();
  useEffect( () => { dispatch(Admin.actions.fetchRecentArchived()) }, [dispatch] )

  const searchRecentArchived = (recent) => {
    if( true
        && ((recent.name && recent.name.toLowerCase().search(searchTerm.toLowerCase()) > -1) || (searchTerm.length === 0))
      )
    {
      return recent
    }  
  }
  const filteredRecentArchived = recentArchived.filter(recent => searchRecentArchived(recent))

  var [show, setShow] = useState(false);
  var [currentName,setCurrentName] = useState('');
  var [currentArchivedDate,setCurrentArchivedDate] = useState('');
  var [currentArchivedby,setCurrentArchivedby] = useState('');
  var [currentTotalsessions,setCurrentTotalsessions] = useState(0);
  var [currentLastcancelledbooking,setCurrentLastcancelledbooking] = useState('');
  var [currentCancellationreasonvar,setCurrentCancellationreasonvar] = useState('');

  const loadRecentArchivedDetail = (thisRecentArchived) => {
    setCurrentName(thisRecentArchived.name)
    setCurrentArchivedDate(thisRecentArchived.archivedate)
    setCurrentArchivedby(thisRecentArchived.archivedby)
    setCurrentTotalsessions(thisRecentArchived.totalsessions)
    setCurrentLastcancelledbooking(thisRecentArchived.lastcancelledbooking)
    setCurrentCancellationreasonvar(thisRecentArchived.cancellationreason)
    setShow(true)
  }

  const columns = [
    { field: 'id', headerName: 'ID', width: 100,  hide: true },
    { field: 'name', headerName: 'Name', width: 300,  
      renderCell: (params) => (
        <strong>
            <div onClick={() => loadRecentArchivedDetail(recentArchived.find(recentArchived => recentArchived.id === params.row.id))} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'archivedby', headerName: 'Archived By', width: 200 },
    { field: 'archivedate', headerName: 'Archived On', width: 150, sortable : true, renderCell: (params) => (format(new Date(params.row.archivedate), "dd-MM-yyyy HH:mm")), cellClassName: 'grid-mono-font' },
    { field: 'totalsessions', headerName: 'Total Sessions', width: 170 },
    { field: 'lastcancelledbooking', headerName: 'Last Cancelled Booking', width: 250, sortable : true, renderCell: (params) => params.row.lastcancelledbooking ? (format(new Date(params.row.lastcancelledbooking), "dd-MM-yyyy HH:mm")) : 'No Recent Cancellations', cellClassName: 'grid-mono-font' },
    { field: 'cancellationreason', headerName: 'Lasted Cancelled Reason', width: 300 },
  ];

  
  function handleClose() {
    setShow(false);
  }  

  const handleSearch = (event) => {
    const searchTerm = event.target.value    
    setSearchTerm(searchTerm)
  }


  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item><h4 style={{ marginBottom: 12 }}>Recently Archived Client</h4></Grid>
      </Grid>

      <Paper> 
        <Grid container style={{ padding: 10 }}>
          <Grid item style={{ marginTop: 2, marginLeft: 10 }}>
            <InputGroup size="sm" >
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control                  
                  type="text"
                  value={searchTerm}
                  onChange={(event) => handleSearch(event)}
                  autoComplete='OFF'
                />
              </InputGroup>
          </Grid>
        </Grid>
      </Paper>

      { recentArchived ? 
        <Paper style={{ height: 700 }}>
          <DataGrid rows={filteredRecentArchived} columns={columns} pageSize={10} checkboxSelection={false} rowHeight={40} />
        </Paper>
      : ('None')
      }

      <Modal show={show} onHide={handleClose} dialogClassName="contracts-modal" >
        <Modal.Header closeButton className="contracts-modal">
          <Modal.Title>Recently Archived Client - {currentName} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="contracts-modal">
          <Row>
            <Col md="6">
              <Form.Group >
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentName} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="3">  
              <Form.Group >
                <Form.Label>Archived Date</Form.Label>
                <Form.Control type="text" name="Archived Date" defaultValue={currentArchivedDate} disabled />
              </Form.Group>
            </Col>
            <Col md="6">  
              <Form.Group >
                <Form.Label>Archived By</Form.Label>
                <Form.Control type="text" name="Archived By" defaultValue={currentArchivedby} disabled />
              </Form.Group> 
            </Col>
          </Row>
          <Row>
            <Col md="3">  
              <Form.Group >
                <Form.Label>Total Sessions</Form.Label>
                <Form.Control type="text" name="Total Sessions" defaultValue={currentTotalsessions} disabled />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group >
                <Form.Label>Last Cancelled Booking</Form.Label>
                <Form.Control type="text" name="Last Cancelled Booking" defaultValue={currentLastcancelledbooking} disabled />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group >
                <Form.Label>Cancellation Reason</Form.Label>
                <Form.Control type="text" name="Cancellation Reason" defaultValue={currentCancellationreasonvar} disabled />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="contracts-modal">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>

      </Modal>

    </>
  )
}
